import { CartesianGrid, Line, LineChart } from "recharts";

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";

export function ChartType1({
  total_processed_files,
  snc_success,
  erp_success,
  erp_failed,
  on_hold,
  validation_failed,
  failed,
  duplicate,
}: {
  total_processed_files: number;
  snc_success: number;
  erp_success: number;
  erp_failed: number;
  on_hold: number;
  validation_failed: number;
  failed: number;
  duplicate: number;
}) {
  const chartData = [
    {
      browser: "total_processed_files",
      visitors: total_processed_files,
      fill: "var(--chart-1)",
    },
    { browser: "snc_success", visitors: snc_success, fill: "var(--chart-2)" },
    {
      browser: "erp_success",
      visitors: erp_success,
      fill: "var(--chart-3)",
    },
    { browser: "erp_failed", visitors: erp_failed, fill: "var(--chart-4)" },
    { browser: "on_hold", visitors: on_hold, fill: "var(--chart-4)" },
    {
      browser: "validation_failed",
      visitors: validation_failed,
      fill: "var(--chart-4)",
    },
    {
      browser: "failed",
      visitors: failed,
      fill: "var(--chart-4)",
    },
    {
      browser: "duplicate",
      visitors: duplicate,
      fill: "var(--chart-4)",
    },
  ];

  const chartConfig = {
    visitors: {
      label: "Document",
      color: "hsl(var(--chart-2))",
    },
    total_processed_files: {
      label: "Total Processed Files",
      color: "hsl(var(--chart-1))",
    },
    snc_success: {
      label: "SNC Success",
      color: "hsl(var(--chart-2))",
    },
    erp_success: {
      label: "ERP Success",
      color: "hsl(var(--chart-3))",
    },
    erp_failed: {
      label: "ERP Failed",
      color: "hsl(var(--chart-4))",
    },
    on_hold: {
      label: "Erp Hold",
      color: "hsl(var(--chart-4))",
    },
    validation_failed: {
      label: "Validation failed",
      color: "hsl(var(--chart-4))",
    },
    failed: {
      label: "Failed",
      color: "hsl(var(--chart-4))",
    },
    duplicate: {
      label: "Duplicate",
      color: "hsl(var(--chart-4))",
    },
  } satisfies ChartConfig;
  return (
    <div className="h-[70px] w-[200px] translate-y-[-5px]">
      <ChartContainer className="h-full w-full " config={chartConfig}>
        <LineChart
          accessibilityLayer
          data={chartData}
          margin={{
            top: 24,
            left: 24,
            right: 24,
            bottom: 24,
          }}
        >
          <CartesianGrid vertical={false} />
          <ChartTooltip
            cursor={false}
            content={
              <ChartTooltipContent
                indicator="line"
                nameKey="visitors"
                labelKey="browser"
              />
            }
          />
          <Line
            dataKey="visitors"
            type="natural"
            stroke="var(--color-visitors)"
            strokeWidth={2}
            // dot={({ payload, ...props }) => {
            //   return (
            //     <Dot
            //       key={payload.browser}
            //       r={5}
            //       cx={props.cx}
            //       cy={props.cy}
            //       fill={payload.fill}
            //       stroke={payload.fill}
            //     />
            //   );
            // }}
          />
        </LineChart>
      </ChartContainer>
    </div>
  );
}
